export default __webpack_public_path__ + "8800a95671d6cf37962a346d4fc0940b.svg";